import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

/**
 * Inline upgrade prompt rendered when the backend returns 403 premium_required.
 * Usage: render conditionally when state.error?.code === "premium_required".
 */
export default function PremiumGate({ feature, testId = "premium-gate" }) {
  const { t, lang } = useLang();
  return (
    <div
      data-testid={testId}
      className="border-2 border-[#D90429] bg-white p-8 md:p-12 max-w-2xl mx-auto my-12"
    >
      <div className="flex items-start gap-4 mb-5">
        <div className="w-10 h-10 bg-[#D90429] text-white flex items-center justify-center flex-shrink-0">
          <Lock className="w-5 h-5" strokeWidth={2.5} />
        </div>
        <div>
          <div className="font-mono-tech text-[10px] tracking-[0.3em] text-[#D90429] uppercase mb-1">
            · {lang === "es" ? "Función premium" : "Premium feature"}
          </div>
          <h2 className="font-serif-display text-2xl md:text-3xl font-bold leading-tight">
            {feature ||
              (lang === "es"
                ? "Esta función requiere un plan superior"
                : "This feature requires a higher plan")}
          </h2>
        </div>
      </div>
      <p className="text-base text-[#404040] font-serif-display italic leading-snug mb-6">
        {t("billing_premium_locked")}
      </p>
      <div className="flex gap-3 flex-wrap">
        <Link
          to="/pricing"
          data-testid={`${testId}-cta-upgrade`}
          className="px-6 py-3 bg-[#D90429] text-white hover:bg-[#A60023] font-mono-tech text-xs uppercase tracking-[0.2em]"
        >
          {t("billing_view_plans")} →
        </Link>
        <Link
          to="/app/billing"
          data-testid={`${testId}-cta-manage`}
          className="px-6 py-3 border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-mono-tech text-xs uppercase tracking-[0.2em]"
        >
          {t("billing_title")}
        </Link>
      </div>
    </div>
  );
}
